// src/pages/clients/forms/ClientContactForm.jsx
import React from 'react';
import { EntityContactForm } from '../../../components/shared/forms';

/**
 * Client contact form component using the shared EntityContactForm
 * with backward compatibility support
 */
const ClientContactForm = ({ 
  clientData, 
  data,
  onChange, 
  onNestedChange, 
  onContactsChange,
  setFieldValue,
  errors = {},
  touched = {},
}) => {
  // Support both new data prop and legacy clientData prop
  const formData = data || clientData || {};
  
  return (
    <EntityContactForm
      data={formData}
      onChange={onChange}
      onNestedChange={onNestedChange}
      onContactsChange={onContactsChange}
      setFieldValue={setFieldValue}
      errors={errors}
      touched={touched}
      showAddress={true}
      showContacts={true}
      sectionTitles={{
        address: 'Address Information',
        contacts: 'Contact Persons'
      }}
      contactConfig={{
        primaryLabel: 'Primary Contact',
        setPrimaryLabel: 'Set as Primary Contact',
        addLabel: 'Add Contact',
        contactIndexLabel: 'Contact'
      }}
      requirePrimaryContact={true}
    />
  );
};

export default ClientContactForm;